import { render, staticRenderFns } from "./BurialScheduleDay.vue?vue&type=template&id=121e7660&scoped=true"
import script from "./BurialScheduleDay.vue?vue&type=script&lang=js"
export * from "./BurialScheduleDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121e7660",
  null
  
)

export default component.exports